import {NgModule} from "@angular/core";
import {RouterModule, Routes,NoPreloading,PreloadAllModules} from "@angular/router";
import {NotFoundComponent} from "./not_found.component";
import {SessionExpireComponent} from "./session-expire.component";
import {routePaths} from "./core/config";

const routes: Routes = [
        {
                path: routePaths.index,
                loadChildren:()=>import('../app/login/login.module').then(m=>m.LoginModule),
                pathMatch: 'prefix'
        }, {
                path: routePaths.home,
                loadChildren:()=>import('../app/home/home.module').then(m=>m.HomeModule),
                pathMatch: 'prefix'
        },
        {path: routePaths.sessionExpire, component: SessionExpireComponent},
        {path: routePaths.notFound, component: NotFoundComponent},
        {path: '**', redirectTo: routePaths.notFound}
];

@NgModule({
        imports: [RouterModule.forRoot(routes)],
        exports: [RouterModule],
})
export class AppRoutingModule {
}

// 